import { render, staticRenderFns } from "./RdbDatastoreUpdateDialog.vue?vue&type=template&id=a1536d1c&"
import script from "./RdbDatastoreUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./RdbDatastoreUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports